export default __webpack_public_path__ + "static/media/canopius.334b833a.png";